import Meta from '@src/components/Meta';
import BloodHomeTemplate from '@src/components/Template/BloodHome';
import PageTemplate from '@src/components/Template/Page';
import { metaInfo } from '@src/data/meta';
import useBlood from '@src/hooks/useBlood';
import { fetchBloodHomeList } from '@src/hooks/useBloodHome';
import { BloodKeys } from '@src/keys/bloodKey';
import keywordAtom from '@src/recoils/atom/keyword';
import { blood } from '@src/services/api';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { useRecoilValue } from 'recoil';
import NotFoundIcon from '@src/assets/imgs/blood-home/notfound.svg';
import { useEffect } from 'react';
import LoadingBloodHomeSkeleton from '@src/components/SkeletonBloodHome';
import styled from 'styled-components';

const EmptyArray = new Array(20).fill(0);

export const getServerSideProps: GetServerSideProps = async () => {
  const queryClient = new QueryClient();
  await queryClient.prefetchQuery(
    [BloodKeys.home],
    async () => await blood.getBloodHome('')
  );
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};

const BloodHomeReviewPage = () => {
  const { bloodHomeReview } = metaInfo;
  const keyword = useRecoilValue(keywordAtom);
  const { fetchBloodHomeList } = useBlood();
  const { data: bloodHomeList, isLoading } = fetchBloodHomeList(keyword);
  console.log(bloodHomeList);
  useEffect(() => {
    const ScrollY = sessionStorage.getItem('bloodHomes_scroll');
    if (Number(ScrollY) !== 0) window.scrollTo(0, Number(ScrollY));
  }, []);
  console.log(isLoading, EmptyArray);

  return (
    <>
      <Meta
        title={bloodHomeReview.title}
        description={bloodHomeReview.description}
        ogImage={bloodHomeReview.ogImage}
      />
      <PageTemplate href={'/blood-home'} mainText={'헌혈리뷰'}>
        {isLoading && (
          <SkeletonContainer>
            {EmptyArray.map((e) => (
              <LoadingBloodHomeSkeleton />
            ))}
          </SkeletonContainer>
        )}
        <BloodHomeTemplate bloodHomeList={bloodHomeList!} />
      </PageTemplate>
    </>
  );
};

const SkeletonContainer = styled.div`
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
`;

export default BloodHomeReviewPage;
